import { RefObject } from 'react';
import HighchartsReact from 'highcharts-react-official';
import { actionTypes as ToastsActionTypes } from 'modules/toastContainer/actionTypes';

import { ActionTypes } from '../ducks/actionTypes';
import { GoalAnalyticsData, GoalAnalyticsMetricKey, HistogramValue } from './goalAnalytics';
import { Dataset } from './common';

type TimeValueType = {
  time: number;
  value: number;
};

type histogramType = {
  buckets: TimeValueType[];
};

export type ChartDataProps = {
  value: number;
  histogram: histogramType;
};

export interface GoalPerformanceChartProps {
  graphData: HistogramValue;
  innerRef: RefObject<HighchartsReact>;
}

export enum GoalPerformanceMetricKeyEnum {
  GOAL_PERFORMANCE = 'Goal Performance',
}

type SelectedMetricsValue = {
  [GoalPerformanceMetricKeyEnum.GOAL_PERFORMANCE]: string;
};

export type GoalPerformanceRequest = {
  campaignIds: number[];
  startTime: string;
  endTime: string;
  selectedMetrics: SelectedMetricsValue[];
};

export type GoalPerformanceAction<T = Record<string, unknown>> = {
  type: ActionTypes | ToastsActionTypes;
  payload?: GoalAnalyticsData;
} & T;

export type GoalPerformanceMetrics = {
  highLevel: Record<string, any>;
  results: Record<string, any>;
};

export type GoalPerformanceMetricsProps = {
  metricData: Record<string, number>;
};

export type PeriodReportingProps = {
  value: number;
  previousValue: number;
};

export type GoalPerformanceState = Partial<{
  metrics: Dataset;
  previousMetrics: Dataset;
  revenue: Dataset;
  previousRevenue: Dataset;
  loading: boolean;
  error: boolean;
}>;

export enum GoalPerformanceMetricsEnum {
  TotalGoalConversions = 'TotalGoalConversions',
  GoalConversionRate = 'GoalConversionRate',
  UniqueGoalConversions = 'UniqueGoalConversions',
  UniqueGoalConversionRate = 'UniqueGoalConversionRate',
}

export type HelpIconProps = {
  tooltipText: string;
};

export type PerformanceMetrics = { [k in GoalAnalyticsMetricKey]: number };
